import { Button, ModalDialog, ModalOverlay } from '@flos/react-ui';
import { useHippoText } from '../../../../hooks/useHippoText';

const HouseBBRBackModal = ({
    showModal,
    saveAndCloseModal,
    cancelAndCloseModal
}: {
    showModal: boolean;
    saveAndCloseModal: () => void;
    cancelAndCloseModal: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    return (
        <ModalOverlay isOpen={showModal}>
            <ModalDialog closeIconHandler={saveAndCloseModal}>
                <div className="u-spacing-inset-l">
                    <div className="u-spacing-inset-l--stretch-max">
                        <h4 className="u-spacing-stack-sm">
                            {getHippoText('DSS-COVERABLE-INFORMATION-STEP-BBR-CANCEL-TITLE')}
                        </h4>
                        <p className="u-spacing-stack-sm">
                            {getHippoText('DSS-COVERABLE-INFORMATION-STEP-BBR-CANCEL-SUBTITLE')}
                        </p>
                    </div>
                    <Button onClick={saveAndCloseModal}>
                        {getHippoText('DSS-COVERABLE-INFORMATION-STEP-BBR-SAVE')}
                    </Button>
                    <Button onClick={cancelAndCloseModal} theme="secondary">
                        {getHippoText('DSS-COVERABLE-INFORMATION-STEP-BBR-CANCEL')}
                    </Button>
                </div>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default HouseBBRBackModal;
